module.exports = __webpack_public_path__ + "img/outro-hero.3c0cfe61.png";